// Module
var code = "<template>\n    <require from=\"./../order/order-list-table\"></require>    \n    <order-list-table if.bind=\"params.Id\" params.bind=\"params\" context=\"customer-view\" customerid.bind=\"params.Id\"></order-list-table>\n</template> \n";
// Exports
export default code;